import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable';
import { _throw } from 'rxjs/observable/throw';
import { catchError } from 'rxjs/operators';

import { ssoConfig } from './sso.config';

function originOf(url: string): string {
  const match = /^(https?:\/\/[^\/?#]+)/i.exec(url || '');
  return match ? match[1].toLowerCase() : null;
}

// Ticket que foi no Basic de uma chamada ao Alfresco (o 401 de um ticket ja trocado nao pede outro ao SSO).
function basicCredential(auth: string): string {
  if (!auth || auth.indexOf('Basic ') !== 0) {
    return undefined;
  }
  try {
    return window.atob(auth.substring(6));
  } catch (e) {
    return undefined;
  }
}

// Backends do pcdoc que recebem o token do SSO e o ticket; o resto (viacep, rotas, etc.) nao recebe nada.
const API_ORIGINS = [environment.API, environment.APIpublic].map(originOf).filter((origin) => !!origin);
const ALFRESCO_ORIGIN = originOf(environment.AlfrescoAPI);

@Injectable()
export class SsoHeaderInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const sso = (window as any).authSsoInstance;
    // Chamadas ao proprio SSO saem como o AuthSsoService montou (token endpoint sem Bearer, /api com o token atual).
    if (!sso || req.url.indexOf(ssoConfig.issuer + '/') === 0) {
      return next.handle(req);
    }

    const origin = originOf(req.url);
    const ticket = sso.getAlfrescoTicket();

    if (origin && origin === ALFRESCO_ORIGIN && req.url.indexOf('/alfresco/') !== -1) {
      return this.sendToAlfresco(req, next, ticket, sso);
    }
    if (!origin || API_ORIGINS.indexOf(origin) === -1) {
      return next.handle(req);
    }

    // Os services do RM montam os headers uma vez, quando nascem: o token do SSO vence em 15 min e o ticket pode ser
    // renovado. A pcdoc-api identifica o usuario pelo Bearer e usa o ticket para falar com o Alfresco por ele.
    let headers = req.headers;
    if (ticket) {
      headers = headers.set('ticket', ticket);
    }
    const token = sso.getAccessToken();
    if (token) {
      headers = headers.set('Authorization', 'Bearer ' + token);
    }
    return next.handle(req.clone({ headers: headers }));
  }

  // O Alfresco nao aceita o JWT do SSO: as chamadas diretas a ele autenticam com o ticket em Basic, como o ADF faz.
  // O header 'ticket' fica de fora, porque o CORS do Alfresco recusa o preflight com ele.
  private sendToAlfresco(req: HttpRequest<any>, next: HttpHandler, ticket: string, sso: any): Observable<HttpEvent<any>> {
    let headers = req.headers.delete('ticket');
    let auth = headers.get('Authorization');
    if (ticket && (!auth || auth.indexOf('Basic ') !== 0)) {
      auth = 'Basic ' + window.btoa(ticket);
      headers = headers.set('Authorization', auth);
    }
    const sentTicket = basicCredential(auth);
    return next.handle(req.clone({ headers: headers })).pipe(
      catchError((err: HttpErrorResponse) => {
        // Ticket morto no Alfresco: o SSO devolve outro ou, se tambem recusar, encerra a sessao.
        if (err.status === 401 && sso.hasSsoSession()) {
          sso.recoverAlfrescoTicket(undefined, sentTicket);
        }
        return _throw(err);
      })
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/sso/sso-header.interceptor.ts